import { render, staticRenderFns } from "./Calling.vue?vue&type=template&id=ab0f4e50"
import script from "./Calling.vue?vue&type=script&lang=js"
export * from "./Calling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports